import React, { memo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Data
import { TextSliderData02 } from './TextSliderData';

const TextSlider02 = (props) => {
  const { t, i18n } = useTranslation(); // الوصول إلى الترجمات وإعدادات i18n
  const isRtl = i18n.language === 'ar'; // تحديد اتجاه النص

  return (
    <div className={props.className} style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      <Swiper
        className="text-slider-02 black-move"
        modules={[Autoplay, Pagination, Navigation]}
        {...props.carousalOption}
        dir={isRtl ? 'rtl' : 'ltr'} // دعم اتجاه السلايدر
      >
        {props.data.map((item, i) => (
          <SwiperSlide key={i}>
            <div
              className={`cover-background items-start flex ${isRtl ? 'justify-start' : 'justify-end'} p-[4.5rem] lg:p-12 md:p-16 xs:p-12`}
              style={{ backgroundImage: `url(${item.img})` }}
            >
              <div className="absolute h-full w-full top-0 left-0 overlay bg-darkgray"></div>
              <div className="text-wrapper flex flex-col w-[50%] bg-white box-shadow-extra-large no-transition p-[4.5rem] pt-0 slider-zoom-content z-[1] relative xl:w-[75%] xl:p-[3rem] lg:w-[80%] lg:p-[2.5rem] md:w-[55%] md:p-[4.5rem] sm:w-[60%] xs:w-full">
                <h3
                  className={`heading-4 ${isRtl ? '-ml-8' : '-mr-8'} -mt-20 mb-10 w-20 text-[#fff] text-center pb-4 pt-24 bg-[#f4d956] text-[40px] leading-[3.4rem] font-medium font-serif ${isRtl ? 'self-start' : 'self-end'} lg:w-[75px] md:mt-[-50px]`}
                >
                  {i + 1 >= 10 ? '' : '0'}
                  {i + 1}
                </h3>
                <h4
                  className="heading-5 font-serif text-darkgray text-[2.3rem] leading-[3rem] p-0 mb-[25px] -tracking-[.5px] lg:mb-[15px] md:text-[27px] sm:text-[25px]"
                  style={{ textAlign: isRtl ? 'right' : 'left' }}
                >
                  <span className={`font-semibold ${isRtl ? 'ml-[5px]' : 'mr-[5px]'} block md:inline-block xs:block`}>
                    {item.title}
                  </span>
                  {item.subtitle}
                </h4>
                {item.content && (
                  <p
                    className="text-xmd mb-[25px] leading-[32px] md:mb-[20px] xs:mb-[15px]"
                    style={{ textAlign: isRtl ? 'right' : 'left' }}
                  >
                    {item.content}
                  </p>
                )}
                {(item.buttonTitle || item.buttonLink) && (
                  <Link
                    aria-label={t('text_slider.button_aria_label')}
                    className="font-medium text-darkgray font-serif no-underline hover:text-[#969896] cursor-pointer flex items-center"
                    to={item.buttonLink ? item.buttonLink : '#'}
                  >
                    {item.buttonTitle}
                    <i
                      className={`line-icon-Arrow-Out${isRtl ? 'Left' : 'Right'} text-[40px] inline-block ${isRtl ? 'mr-[15px]' : 'ml-[15px]'} align-middle`}
                    ></i>
                  </Link>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

TextSlider02.defaultProps = {
  data: TextSliderData02,
};

TextSlider02.propTypes = {
  className: PropTypes.string,
  carousalOption: PropTypes.object,
  data: PropTypes.arrayOf(
    PropTypes.exact({
      img: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      content: PropTypes.string,
      buttonTitle: PropTypes.string,
      buttonLink: PropTypes.string,
    })
  ),
};

export default memo(TextSlider02);